export default [
  'symbol',
  'cost',
  'CPV',
  'EPV',
  'profit',
  'revenue',
  'CR',
  'CTR',
  'CV',
  'clicks',
  'visits'
];



// WEBPACK FOOTER //
// ./src/table_module/configs/sortable_columns.js